<div class="flex flex-col w-full">
	<div>
      <label for="user">{{ label() }}</label>
      <input type="text" id="user" placeholder="Buscar por nombre, apellido, email..." [formControl]="searchControl" [matAutocomplete]="user"
        class="input__base">
      <mat-autocomplete #user="matAutocomplete" [displayWith]="displayUser" (optionSelected)="setUser($event)">
        @if(loading()){
        <mat-option>
          Buscando...
        </mat-option>
        }
        @for (user of users(); track user) {
        <mat-option [value]="user">
			<div><strong>{{getName(user)}}</strong></div>
			<div>{{user.email}}</div>
		</mat-option>
        }
      </mat-autocomplete>
     
    </div>
	
</div>
